import script from "./DefBarcode.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefBarcode.vue?vue&type=script&lang=ts&setup=true"

import "./DefBarcode.vue?vue&type=style&index=0&id=7e235dee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e235dee"]])

export default __exports__